import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./pages/LoginForm";
import { SignupInApp } from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import DeviceDetail from "./pages/DeviceDetail";
import Provisioning from "./pages/Provisioning";
import MobileApp from "./pages/MobileApp";
import Defaults from "./pages/Defaults";
import Account from "./pages/Account";
import DeviceCTOValidation from "./pages/DeviceCTOValidation";
import { consoleFeatures } from "./config/consoleFeatures";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function PublicOnly({ children }) {
  const token = localStorage.getItem("token");
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicOnly><Login /></PublicOnly>} />

        <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/:id" element={<DeviceDetail />} />
          <Route path="/provisioning" element={<Provisioning />} />
          <Route
            path="/mobile-app"
            element={consoleFeatures.enableMobileAppPage ? <MobileApp /> : <Navigate to="/dashboard" replace />}
          />
          <Route
            path="/defaults"
            element={consoleFeatures.enableDefaultsPage ? <Defaults /> : <Navigate to="/dashboard" replace />}
          />
          <Route path="/signup-user" element={<SignupInApp />} />
          <Route path="/account" element={<Account />} />
          <Route path="/DeviceCTOValidation/:id" element={<DeviceCTOValidation />} />
          <Route path="/device/:id" element={<LegacyDeviceRedirect />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function LegacyDeviceRedirect() {
  const id = window.location.pathname.split("/").pop();
  return <Navigate to={`/devices/${id}`} replace />;
}

export default App;
